// Export Constants
export const SET_HOST = 'SET_HOST'


// Export type
export const setHost = (host) => ({ type: SET_HOST, host })
